module.exports = __webpack_public_path__ + "static/the-yellow-house-4ebb1eeebe6d58e831d383e7772d9609.jpg";